let environment = "dev";
if (/(app|jobs|www).workstep.com/.test(window.location.host)) {
    environment = "prod";
} else if (/stage.workstep.com/.test(window.location.host)) {
    environment = "stage";
} else if (/demo.workstep.com/.test(window.location.host)) {
    environment = "demo";
}

const s3BucketMap = {
    dev: "ws-resume-ingestion-development",
    stage: "ws-resume-ingestion-stage",
    demo: "ws-resume-ingestion-demo",
    prod: "ws-resume-ingestion-production",
};

export default {
    IS_DEV: environment === "dev",
    IS_STAGE: environment === "stage",
    IS_DEMO: environment === "demo",
    IS_PROD: environment === "prod",

    cleave: {
        PHONE_CONFIG: {
            numericOnly: true,
            delimiter: "-",
            blocks: [3, 3, 4],
        },
        DATE_CONFIG: {
            date: true,
            datePattern: ["m", "d", "Y"],
        },
        SHORT_DATE_CONFIG: {
            numericOnly: true,
            delimiter: "/",
            blocks: [2, 4],
        },
    },
    aws: {
        bucketName: s3BucketMap[environment],
        bucketRegion: "us-west-2",
        identityPoolID: "us-west-2:8ab21d97-d5cb-46af-9b2d-e2cbb5924588",
    },
    RESUME_STATUS: {
        ADDED: 1,
        NOT_WANT: 2,
        MISSING: 3,
    },
    RESUME_GET_PARAM_FOR_RELOAD: {
        KEY: "ws-resume-reload",
        VALUE: 1,
    },

    WAGE_MIN: 11,
    WAGE_MAX: 40,
    GUT_CHECK_MAX_KEYWORDS: 4,
};
